module.exports = __webpack_public_path__ + "img/starter.3b85340d.png";